import Requisicao from "./RequisicaoService";

class NotificacaoService {
    static async listar(idCliente) {
        return Requisicao.get('notificacao/' + idCliente);
    }    

    static async load(hash) {
        return Requisicao.get('notificacao/load/' + hash);
    }  

    static async gravar(dados) {                    
        return Requisicao.post('notificacao', JSON.stringify(dados), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }   

    static async delete(uuid) {                    
        return Requisicao.delete('notificacao/' + uuid);
    } 

    static async changeStatus(uuidNotificacaoCab, status) {                    
        return Requisicao.post('notificacao/changeStatus', {
            uuidNotificacaoCab: uuidNotificacaoCab,
            status: status
        });
    }
}

export default NotificacaoService;